export default __webpack_public_path__ + "static/media/hirota.6e5eab1c.png";